import axios from "axios";

const ENV = process.env.NODE_ENV === 'production';

class Http {

  request(url, method = 'get', data = {}) {
    url = (ENV ? '/json' : '/json') + url
    // console.log(url)
    let options = {
      url,
      method
    }
    if (method === 'get') {
      options = {
        ...options,
        params: data
      }
    } else if (method === 'post') {
      options = {
        ...options,
        data
      }
    }
    //创建请求
    const instance = axios.create()
    //请求拦截
    instance.interceptors.request.use(config => {
      return config
    })
    //响应拦截
    instance.interceptors.response.use(response => {
      return response.data
    }, err => {
      console.log('响应出错了' + err)
      return err
    })
    return instance.request(options)
  }

  get(url, data = {}) {
    return this.request(url, 'get', data)
  }

  post(url, data = {}) {
    return this.request(url, 'post', data)
  }
}

export default new Http()